/**
 * Spanish translation state for CMS resources.
 *
 * `resources.translation_status` is the CMS flag. A few resources have their
 * Spanish version as a static route (src/routes/es.recursos.<slug_es>.tsx)
 * while the CMS row still says `missing` with an empty body_es. Static routes
 * win over /es/recursos/$slug, so those pages are real translations and must
 * keep their hreflang pair, sitemap alternates and Spanish hub listing.
 *
 * Every consumer of translation_status must go through
 * isSpanishTranslationMissing() so the CMS flag and the static routes cannot
 * disagree. scripts/audit-resource-translation.mjs enforces this.
 *
 * Keep this file free of path aliases: it is unit-tested with node --test.
 */

/** EN slug -> static Spanish route. Each entry must have a route file and an
 *  indexable SEO ownership pair. */
export const STATIC_SPANISH_RESOURCE_ROUTES: Readonly<Record<string, string>> = {
  "woocommerce-to-shopify-migration": "/es/recursos/migracion-woocommerce-shopify",
  "shopify-app-bloat-performance": "/es/recursos/bloat-apps-shopify-rendimiento",
};

export type TranslationAware = {
  slug?: string | null;
  translation_status?: string | null;
};

export function hasStaticSpanishRoute(slug: string | null | undefined): boolean {
  return !!slug && Object.prototype.hasOwnProperty.call(STATIC_SPANISH_RESOURCE_ROUTES, slug);
}

/** True only when no Spanish version exists anywhere: the CMS says `missing`
 *  and there is no static Spanish route for the slug. */
export function isSpanishTranslationMissing(resource: TranslationAware | null | undefined): boolean {
  if (!resource || resource.translation_status !== "missing") return false;
  return !hasStaticSpanishRoute(resource.slug);
}
